export class SettingsPojo {

    settingId: number;
    enableDays: number;
    onlineBookingControlDays: number;
    zeroAmountCaption: string;

}
